<template>
    <b-modal :id="modalId" modal-class="modal-checkout-paywithbanktransfer" centered @shown="shown" @hidden="hide"
             no-close-on-esc no-close-on-backdrop hide-header-close hide-header hide-footer>

        <Loader>
            <template #message>{{ $t('pages.checkout.modal_payment_processing_text') }}</template>
        </Loader>
    </b-modal>
</template>


<script>
    import {PAYMENT_METHOD_BANK_TRANSFER} from "@/consts.js"
    import Loader from "@/components/Loader"
    import {mapMutations} from "vuex";

    export default {
        components: {
            Loader,
        },

        props: {
            modalId: {
                type: String,
                required: true
            },
        },

        methods: {
            ...mapMutations('cartDigitalItems', ['resetCart']),
            hide() {
                this.$bvModal.hide(this.modalId)
            },

            showAndPay() {
                this.$bvModal.show(this.modalId)
            },

            async shown() {
                console.log('shown')
                await this.pay()
            },

            async pay() {
                this.isLoadingOrder = true

                this.$store.dispatch("cart/placeOrder", {paymentMethod: PAYMENT_METHOD_BANK_TRANSFER})
                    .then(response => {
                        this.isLoadingOrder = false
                        this.$store.dispatch("cart/emitFbPixelPurchaseEvent", {
                            currency: response.data.currency,
                            amount: response.data.price_grandtotal
                        })
                        this.resetCart()
                        this.$emit('order-success', response.data.id)
                    })
                    .catch(function (error) {
                        console.log('PAY WITH BANK TRANSFER ERROR', error)
                    })
            }
        }
    }
</script>
